import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PrimaryButton } from '../../../shared/ui';

type LoginSubmitButtonProps = {
  canSubmit: boolean;
  onSubmit: () => void;
};

const SubmitLoginButton = styled(PrimaryButton).attrs({
  'data-ui': 'auth-login-submit-button',
})<{ $isDisabled: boolean }>`
  align-self: center;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
`;

export function LoginSubmitButton({
  canSubmit,
  onSubmit,
}: LoginSubmitButtonProps) {
  const { t } = useTranslation();

  return (
    <SubmitLoginButton
      $isDisabled={!canSubmit}
      disabled={!canSubmit}
      type="button"
      onClick={onSubmit}
    >
      {t('login.cta')}
    </SubmitLoginButton>
  );
}
